import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

/** Richiede una sessione attiva, altrimenti porta al login ricordando dove si voleva andare. */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? true : router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

/** Chi e' gia' autenticato non vede la pagina di login. */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.isAuthenticated() ? inject(Router).createUrlTree(['/']) : true;
};

/**
 * Guardia funzionale sui permessi. Attenzione: e' solo UX (nasconde cio' che non serve); la sicurezza vera e'
 * applicata dal backend su ogni endpoint.
 */
export const permissionGuard =
  (...permissions: string[]): CanActivateFn =>
  () => {
    const auth = inject(AuthService);
    return auth.hasAny(...permissions) ? true : inject(Router).createUrlTree(['/non-autorizzato']);
  };

/** Home per ruolo: manda l'utente alla pagina piu' utile in base ai permessi. */
export const homeRedirectGuard: CanActivateFn = (): UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.has('RDA_APPROVE')) return router.createUrlTree(['/rda/approvazioni']);
  if (auth.has('RDA_PURCHASING')) return router.createUrlTree(['/rda/acquisti']);
  // CRM disattivato: if (auth.has('CRM_ACTIVITY_WRITE') && auth.has('DASHBOARD_CRM')) return router.createUrlTree(['/crm/dashboard']);
  if (auth.has('DASHBOARD_RDA') && !auth.hasAny('RDA_CREATE', 'ADMIN_USERS')) return router.createUrlTree(['/rda/dashboard']);
  if (auth.hasAny('RDA_CREATE', 'RDA_READ_OWN', 'RDA_READ_ALL')) return router.createUrlTree(['/rda']);
  if (auth.has('ADMIN_USERS')) return router.createUrlTree(['/admin/utenti']);
  return router.createUrlTree(['/non-autorizzato']);
};
